/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Etaf_Not_Ready_For_SubmissionInputs */

const en_error_etaf_not_ready_for_submission = /** @type {(inputs: Error_Etaf_Not_Ready_For_SubmissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The form isn't complete yet. Fix what's listed and send it again.`)
};

/**
* | output |
* | --- |
* | "The form isn't complete yet. Fix what's listed and send it again." |
*
* @param {Error_Etaf_Not_Ready_For_SubmissionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_etaf_not_ready_for_submission = /** @type {((inputs?: Error_Etaf_Not_Ready_For_SubmissionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Etaf_Not_Ready_For_SubmissionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_etaf_not_ready_for_submission(inputs)
});